const update = ({ experience, category, question }) => {
  const storage = JSON.parse(localStorage.getItem('savedQuestions'));

  if (storage.some(element => element.name === experience)) {
    const newArray = storage.map(element => {
      if (element.name === experience && element.questions) {
        if (element.questions.some(item => item === question)) {
          const newQuestions = element.questions.filter(item => item !== question);

          return {
            name: element.name,
            category,
            questions: newQuestions,
          };
        }

        return {
          name: element.name,
          category,
          questions: [...element.questions, question],
        };
      }

      return element;
    });

    localStorage.setItem(
      'savedQuestions',
      JSON.stringify(
        newArray.filter(element => {
          if (Object.entries(element).length > 1) {
            return !element.questions.length < 1;
          }

          return true;
        })
      )
    );
  } else {
    storage.push({
      name: experience,
      category,
      questions: [question],
    });
    localStorage.setItem('savedQuestions', JSON.stringify(storage));
  }
};

export const questionLike = {
  update,
};
